/* eslint-disable import/prefer-default-export */
import DashECharts from './components/DashECharts.react';

export {
    DashECharts
};
